import { Log } from "../components/user-logs/log.model";
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

export class LogFormatterUtils {
    public translator: any;
    constructor(
        public translateService: TranslateService) {
        this.translator = this.translateService;

        }
    public static getObjectKeys(obj) {
        return (Object.keys(obj));
      }
    
    public static getObjectValues(obj) {
        return (Object.values(obj));
      }
    public static getEntityLog(log: Log, entity: string) {
        if (log.actionReference.indexOf(entity) >= 0) {
            return log.actionReference;
        }
        return 1;
    }

    public static getEntityClass(log: Log) {
        const lastSlashindex = log.entityClass.lastIndexOf("\\");
        const entityClassLength = log.entityClass.length - (lastSlashindex + 1);
        return log.entityClass.substr(-entityClassLength);
    }

    public static getChanges(log: Log) {
        if (log.changes !== null && log.changes !== undefined && log.changes !== '' && log.changes !== 'null') {
            const changes = JSON.parse(log.changes);
            const changesKeys = this.getObjectKeys(changes);
            const changesValues = this.getObjectValues(changes);
            let changesFormatedInLine = '';
            changesKeys.forEach((val, idx) => {
                changesFormatedInLine += val + ' : ' + changesValues[idx][0] + ' - ' + (Array.isArray(changesValues[idx][1]) ? JSON.stringify(changesValues[idx][1]) : changesValues[idx][1] ) + ' ------- ';
            });
            return {changes: changesFormatedInLine};
        }
        return null;
    }

    public static authenTificationLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: ((  (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: entityValue.user.reference
            } 
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;

    }

    public static operatorClkLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: ((  (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {userDest: (( (log.firstnameDest !== null && log.firstnameDest !== undefined) ? log.firstnameDest : '') + ' '
             + ((log.lastnameDest !== null && log.lastnameDest !== undefined) ? log.lastnameDest : ''))},
             
        ];
        
        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static operatorPartnerLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: ((  (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {userDest: (( (log.firstnameDest !== null && log.firstnameDest !== undefined) ? log.firstnameDest : '') + ' '
             + ((log.lastnameDest !== null && log.lastnameDest !== undefined) ? log.lastnameDest : ''))} 
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static organizationLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined)  ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {organizationReference: entityValue.reference},
            {
                organizationName: entityValue.name
            } 
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static agencyLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined)  ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {agencyReference: entityValue.reference},
            {
                agencyName: entityValue.name
            } 
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static organizationConfigModifyFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {organizationReference: entityValue.organization.reference}

        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static platformLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {platformReference: entityValue.reference},
            {platformName: entityValue.name }
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static entityLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {entityReference: entityValue.reference}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static customerLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : '')) },
            {
                userReference: log.userReference
            },
            {customerReference: entityValue.reference},
            {
                customer: (( (entityValue.firstname !== null && entityValue.firstname !== undefined) ? entityValue.firstname : '') + ' '
                + ( (entityValue.lastname !== null && entityValue.lastname !== undefined) ? entityValue.lastname : ''))
            },
            {
                customerPhone: entityValue.phone
            }
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static accountLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : '')) },
            {
                userReference: log.userReference
            },
            {accountReference: entityValue.reference},
            {
             accountNumber: entityValue.accountNumber
            }
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static profileLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : '')) },
            {
                userReference: log.userReference
            },
            {profileReference: entityValue.reference},
            {
               profile: (( (entityValue.firstname !== null && entityValue.firstname !== undefined) ? entityValue.firstname : '') + ' '
                + ( (entityValue.lastname !== null && entityValue.lastname !== undefined) ? entityValue.lastname : ''))
            },
            {
                profilePhone: entityValue.phone
            }
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static callcenterLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {callcenterReference: entityValue.reference},
            {callcenterName: entityValue.name }
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static cityLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {cityReference: entityValue.reference},
            {cityName: entityValue.name }
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static countryLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {countryReference: entityValue.reference},
            {countryName: entityValue.name }
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static monetaryAreaLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {monetaryAreaReference: entityValue.reference},
            {monetaryAreaName: entityValue.name }
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static operationCostLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {operationCostReference: entityValue.reference},
            {operationType: entityValue.operationType },
            {sourceAccountType: entityValue.sourceAccountType},
            {targetAccountType: entityValue.targetAccountType },
            {lowerAmount: entityValue.lowerAmount },
            {topAmount: entityValue.topAmount},
            {cost: entityValue.cost}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static operationRefundLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {operationRefundReference: entityValue.reference},
            {operationType: entityValue.operationType },
            {lowerAmount: entityValue.lowerAmount },
            {topAmount: entityValue.topAmount},
            {fixedAmount: entityValue.fixedAmount}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static restrictionLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {restrictionReference: entityValue.reference},
            {operationType: entityValue.operationType },
            {accountLevel: entityValue.accountLevel },
            {accountType: entityValue.accountType},
            {period: entityValue.period},
            {restrictionType: entityValue.restrictionType},
            {restrictionValue: entityValue.restrictionValue}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static roleLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {roleReference: entityValue.reference},
            {roleName: entityValue.name}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static stateLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {stateReference: entityValue.reference},
            {stateName: entityValue.name}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static operationLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs:any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {operationReference: entityValue.reference},
            {operationType: entityValue.operationType},
            {status: entityValue.status},
            {customer: entityValue.customer ? entityValue.customer.reference : ''},
            {receiver: entityValue.receiver ? entityValue.receiver.reference : ''},
            {amount: entityValue.prefixedAmount},
            {operationCost: entityValue.prefixedOperationCost },
            {receivingAmount: entityValue.prefixedReceivingAmount},
            {description: entityValue.description},
            {agency: entityValue.agency ? entityValue.agency.reference : ''},
            {organization: entityValue.organization ? entityValue.organization.reference : ''},
            {callCenter: entityValue.callCenter ? entityValue.callCenter.reference : ''},
            {platform: entityValue.platform ? entityValue.platform.reference : ''},
            {userOperatorPartner: entityValue.userOperatorPartner ? entityValue.userOperatorPartner.reference : ''},
            {userOperatorClk: entityValue.userOperatorClk ? entityValue.userOperatorClk.reference : ''}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static cascadeLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);

        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {entityConcern: this.getEntityClass(log)},
            {entityReference: entityValue.reference}   
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static defaultLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {entityReference: entityValue.reference ? entityValue.reference : ''}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static depositedAccountOperationLogFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: (( (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ((log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {operationReference: entityValue.reference},
            {operationType: entityValue.operationType},
            {depositAccount: entityValue.depositAccount ? entityValue.depositAccount.reference : ''},
            {status: entityValue.status},
            {amount: entityValue.prefixedAmount},
            {description: entityValue.description},
            {prefixedLastBalance: entityValue.prefixedLastBalance},
            {prefixedNewBalance: entityValue.prefixedNewBalance},
            {agency: entityValue.agency ? entityValue.agency.reference : ''},
            {organization: entityValue.organization ? entityValue.organization.reference : ''},
            {callCenter: entityValue.callCenter ? entityValue.callCenter.reference : ''},
            {targetAgency: entityValue.targetAgency ? entityValue.targetAgency.reference : ''},
            {targetOrganization: entityValue.targetOrganization ? entityValue.targetOrganization.reference : ''},
            {userOperatorClk: entityValue.userOperatorClk ? entityValue.userOperatorClk.reference : ''},
            {userOperatorPartner: entityValue.userOperatorPartner ? entityValue.userOperatorPartner.reference : ''},
            {userOperatorPartnerReceiver: entityValue.userOperatorPartnerReceiver ? entityValue.userOperatorPartnerReceiver.reference : ''}
        ];

        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static userCollectFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: ((  (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {userCollect: (( (entityValue.name !== null &&
                 entityValue.name !== undefined) ? entityValue.name : '' ))
            },
            {userCollectReference: entityValue !== null && entityValue !== undefined ? entityValue.reference : ''
           }
             
        ];
        
        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }

    public static userCollectBankFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: ((  (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {bank: (( (entityValue.name !== null &&
                 entityValue.name !== undefined) ? entityValue.name : '' ))
            },
            {bankReference: entityValue !== null && entityValue !== undefined ? entityValue.reference : ''
           }
             
        ];

        return logs;
    }

    public static userCollectAgencyFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: ((  (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {agency: (( (entityValue.name !== null &&
                 entityValue.name !== undefined) ? entityValue.name : '' ))
            },
            {agencyReference: entityValue !== null && entityValue !== undefined ? entityValue.reference : ''
           }
             
        ];

        return logs;
    }

    public static userCollectProductFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: ((  (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {product: (( (entityValue.name !== null &&
                 entityValue.name !== undefined) ? entityValue.name : '' ))
            },
            {productReference: entityValue !== null && entityValue !== undefined ? entityValue.reference : ''
           }
             
        ];

        return logs;
    }

    public static subUserCollectFormatter(log: Log) {
        const datePipe = new DatePipe('en');
        const entityValue = JSON.parse(log.entityValue);
        let logs: any = [
            {reference: log.reference},
            {logActionDate: datePipe.transform(log.date, 'dd/MM/yyyy HH:mm:ss')},
            {actionType: log.actionReference},
            {user: ((  (log.firstname !== null && log.firstname !== undefined) ? log.firstname : '') + ' '
             + ( (log.lastname !== null && log.lastname !== undefined) ? log.lastname : ''))},
            {
                userReference: log.userReference
            },
            {subUser: (( (entityValue.firstname !== null &&
                entityValue.firstname !== undefined) ? entityValue.firstname : '') + ' '
           + ( (entityValue.lastname !== null && entityValue.lastname !== undefined)
            ? entityValue.lastname : '' ))},
            {subUserReference: entityValue !== null && entityValue !== undefined ? entityValue.reference : ''
            }
        ];
        
        // if (this.getChanges(log)) {
        //     logs.push(this.getChanges(log));
        // }

        return logs;
    }



    public static logFormatter(log: Log) {
        let logFormatted = null;
        switch (log.actionReference) {
            case 'LOGIN':
                logFormatted = this.authenTificationLogFormatter(log);
                break;
            case 'LOGOUT':
                logFormatted = this.authenTificationLogFormatter(log);
                break;
            case this.getEntityLog(log, 'CASCADE'):
                logFormatted = this.cascadeLogFormatter(log);
                break;     
            case this.getEntityLog(log, 'OPERATOR_CLK'):
                logFormatted = this.operatorClkLogFormatter(log);
                break;
            case this.getEntityLog(log, 'OPERATOR_PARTNER'):
                logFormatted = this.operatorPartnerLogFormatter(log);
                break;
            case this.getEntityLog(log, 'COLLECT_USER'):
                logFormatted = this.userCollectFormatter(log);
                break; 
            case this.getEntityLog(log, 'COLLECT_SUB_USER'):
                logFormatted = this.subUserCollectFormatter(log);
                break;
            case this.getEntityLog(log, 'COLLECT_BANK'):
                logFormatted = this.userCollectBankFormatter(log);
                break;   
            case this.getEntityLog(log, 'COLLECT_PRODUCT'):
                logFormatted = this.userCollectProductFormatter(log);
                break;  
            case this.getEntityLog(log, 'COLLECT_AGENCY'):
                logFormatted = this.userCollectAgencyFormatter(log);
                break;             
            case this.getEntityLog(log, 'ORGANIZATION_CONFIGURATION'):
                logFormatted = this.organizationConfigModifyFormatter(log);
                break;
            case this.getEntityLog(log, 'ORGANIZATION'): 
                logFormatted = this.organizationLogFormatter(log);
                break;
            case this.getEntityLog(log, 'AGENCY'):
                logFormatted = this.agencyLogFormatter(log);
                break;    
            case this.getEntityLog(log, 'PLATFORM'):
                logFormatted = this.platformLogFormatter(log);
                break;
            case this.getEntityLog(log, 'ENTITY'):
                logFormatted = this.entityLogFormatter(log);
                break;
              
            case this.getEntityLog(log, 'PROFILE'):
                logFormatted = this.profileLogFormatter(log);
                break; 
            case this.getEntityLog(log, 'CALLCENTER'):
                logFormatted = this.callcenterLogFormatter(log);
                break;  
            case this.getEntityLog(log, 'CITY'):
                logFormatted = this.cityLogFormatter(log);
                break;
            case this.getEntityLog(log, 'COUNTRY'):
                logFormatted = this.countryLogFormatter(log);
                break;
            case this.getEntityLog(log, 'MONETARY_AREA'):
                logFormatted = this.monetaryAreaLogFormatter(log);
                break;   
            case this.getEntityLog(log, 'OPERATION_COST'):
                logFormatted = this.operationCostLogFormatter(log);
                break;
            case this.getEntityLog(log, 'OPERATION_REFUND'):
                logFormatted = this.operationRefundLogFormatter(log);
                break;
            case this.getEntityLog(log, 'RESTRICTION'):
                logFormatted = this.restrictionLogFormatter(log);
                break; 
            case this.getEntityLog(log, 'ROLE'):
                logFormatted = this.roleLogFormatter(log);
                break;
            case this.getEntityLog(log, 'STATE'):
                logFormatted = this.stateLogFormatter(log);
                break;
            case this.getEntityLog(log, 'DEPOSIT_ACCOUNT'):
                logFormatted = this.depositedAccountOperationLogFormatter(log);
                break;
            case this.getEntityLog(log, 'DEPOSIT-ACCOUNT'):
                logFormatted = this.depositedAccountOperationLogFormatter(log);
                break;    
            case this.getEntityLog(log, 'ACCOUNT'):
                logFormatted = this.accountLogFormatter(log);
                break;    
            case this.getEntityLog(log, 'OPERATION'):
                logFormatted = this.operationLogFormatter(log);
                break;
            case this.getEntityLog(log, 'CUSTOMER'):
                logFormatted = this.customerLogFormatter(log);
                break;                                                                                       
            default:
                logFormatted = this.defaultLogFormatter(log);
                break;

        }
        return logFormatted;
    }
}


// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/utils/LogFormatterUtils.ts